import React from "react"
import { link } from "../styles/link.module.css"

export default function TeamLink({ url, destination }) {
  return (
    <div className={link}>
      <span className={link}>
        <b>Meet The</b>
      </span>
      <a href={url}>{destination}</a>
    </div>
  )
}
